/**
 * Checks if the "<head>" element already contains an recaptcha script.
 *
 * @param scriptName {string} The name of the script, this will technically be the key/name of an attribute on the script tag
 *
 * @returns {boolean} true if reCAPTCHA script found
 */
const hasScript = scriptName => {
	// Get list of all scripts
	const scripts = document.head.getElementsByTagName('script');

	// Loop through each script and search the script for the custom attribute we add in loadScript()
	for (const script of scripts) {
		// If custom attribute is found the script has been added, return true
		if (script.hasAttribute(scriptName)) {
			return true;
		}
	}

	return false;
};

/** TODO: this is nearly the exact code in the recaptcha class and should be moved to a shared file
 * This is not really needed, with how these have been stripped down from their original recaptcha class functionality
 * perhaps we'll build this out more in the future and this will be of use?
 *
 * @param callback {function} Callback to call after the library has been loaded successfully.
 * @param scriptName {string} The script's name, this will be added as an attribute to the script tag itself
 */
const waitForScriptToLoad = (callback, scriptName) => () => { // Not sure if this needs to be written with this anonymous function, but it is the same in recaptcha class so keeping it the same here
	// Check if markup contains a script tag with the script's name as an attribute
	if (!hasScript(scriptName)) {
		setTimeout(() => {
			// Re-run this function until the script exists
			waitForScriptToLoad(callback, scriptName);
		}, 100);
	} else {
		callback();
	}
};

/** TODO: this is nearly the exact code in the recaptcha class and should be moved to a shared file
 * Create a script element and append it to '<head>'
 *
 * @param scriptName {string} This is an attribute added to the script tag with a value of "", which will be used to access the specific script
 * @param src {string} The script source, typically a url
 *
 * @returns {Promise}
 */
const loadScript = (scriptName, src) => {
	// Create a script element
	const scriptElement = document.createElement('script');

	// Add a custom attribute with he script's name (this is used later to avoid adding the same script multiple times)
	scriptElement.setAttribute(scriptName, '');

	// Add type attribute
	scriptElement.setAttribute(`type`, `text/javascript`);

	// The source of the script
	scriptElement.src = src;

	// Return a promise
	return new Promise((resolve, reject) => {
		// Don't resolve the promise until the script has actually loaded
		scriptElement.addEventListener('load', waitForScriptToLoad(() => resolve(scriptElement), scriptName), false);

		scriptElement.onerror = error => {
			reject(new Error(`Something went wrong while loading ${name} script. (${error.toString()})`));
		};

		// Add script to '<head>'
		document.head.appendChild(scriptElement);
	});
};

/**
 * Attempt to add script tags to the markup if they do not already exist for the given scriptName
 *
 * @param scriptName {string} This is an attribute added to the script tag with a value of "", which will be used to access the specific script
 * @param src {string} The script source, typically a url
 * @param callback {function} Callback to call after the library has been loaded successfully
 */
const addScript = (scriptName, src, callback) => {
	// If the script has already been attached
	if (hasScript(scriptName)) {
		callback();
		// The script is not in the markup yet, then , lastly
	} else {
		// Add the script
		loadScript(scriptName, src)
			.then(() => {
				// Run the passed callback
				callback();
			});
	}
};

export default addScript;
